import "core-js/modules/es.array.index-of.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('v-container', {
    staticClass: "d-flex flex-column justify-end white pl-4 pr-0 pb-4 pt-0 chat-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.exibirFaq,
      expression: "exibirFaq"
    }],
    staticClass: "mensagens pr-4"
  }, [_c('div', {
    staticClass: "mt-3"
  }, [_c('ml-faq')], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.exibirFaq,
      expression: "!exibirFaq"
    }],
    staticClass: "mensagens pr-4",
    attrs: {
      "id": "mensagens"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l(_vm.mensagens, function (mensagem, index) {
    return _c('div', {
      key: index + 'A',
      "class": {
        'mt-4': !mensagem.notMt,
        'mr-8': ['texto-sistema', 'erro'].indexOf(mensagem.tipo) !== -1,
        'ml-8': ['texto-cliente'].indexOf(mensagem.tipo) !== -1,
        'd-flex': ['texto-cliente'].indexOf(mensagem.tipo) !== -1,
        'justify-center': [].indexOf(mensagem.tipo) !== -1,
        'justify-end': ['texto-cliente'].indexOf(mensagem.tipo) !== -1,
        'align-center': [].indexOf(mensagem.tipo) !== -1
      }
    }, [['texto-sistema', 'texto-cliente', 'whatsapp'].indexOf(mensagem.tipo) !== -1 ? _c('div', {
      "class": {
        'pa-2': ['whatsapp'].indexOf(mensagem.tipo) !== -1,
        'pa-4': ['texto-sistema', 'texto-cliente'].indexOf(mensagem.tipo) !== -1,
        'rounded-xl': ['whatsapp'].indexOf(mensagem.tipo) === -1,
        'rounded-lg': ['whatsapp'].indexOf(mensagem.tipo) !== -1,
        'rounded-tl-0': ['texto-sistema'].indexOf(mensagem.tipo) !== -1,
        'rounded-br-0': ['texto-cliente'].indexOf(mensagem.tipo) !== -1,
        'grey lighten-4': ['texto-sistema'].indexOf(mensagem.tipo) !== -1,
        'ml-bg-credor': ['texto-cliente', 'whatsapp'].indexOf(mensagem.tipo) !== -1,
        'ml-width-fit-content': ['texto-sistema', 'texto-cliente'].indexOf(mensagem.tipo) !== -1,
        'd-flex': ['whatsapp'].indexOf(mensagem.tipo) !== -1,
        'justify-center': ['whatsapp'].indexOf(mensagem.tipo) !== -1,
        'align-center': ['whatsapp'].indexOf(mensagem.tipo) !== -1
      },
      staticStyle: {
        "max-width": "100%"
      }
    }, [mensagem.tipo == 'whatsapp' ? _c('img', {
      staticClass: "mr-3",
      attrs: {
        "alt": "logo-whatsapp",
        "src": require("../assets/img/logo-whatsapp.svg")
      }
    }) : _vm._e(), _c('p', {
      staticClass: "mb-0",
      "class": {
        'ml-font-16': ['texto-sistema', 'texto-cliente'].indexOf(mensagem.tipo) !== -1,
        'ml-font-18': ['whatsapp'].indexOf(mensagem.tipo) !== -1,
        'font-weight-bold': ['whatsapp'].indexOf(mensagem.tipo) !== -1
      }
    }, [_vm._v(" " + _vm._s(mensagem.conteudo) + " ")])]) : _vm._e(), mensagem.tipo == 'input' ? _c('v-form', {
      ref: "form",
      refInFor: true,
      attrs: {
        "lazy-validation": ""
      },
      on: {
        "submit": function submit($event) {
          $event.preventDefault();
          return mensagem.conteudo.submit.apply(null, arguments);
        }
      },
      model: {
        value: _vm.valid,
        callback: function callback($$v) {
          _vm.valid = $$v;
        },
        expression: "valid"
      }
    }, [_c('v-text-field', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: mensagem.conteudo.mask,
        expression: "mensagem.conteudo.mask"
      }],
      attrs: {
        "required": "",
        "outlined": "",
        "type": mensagem.conteudo.tipo,
        "label": mensagem.conteudo.label,
        "rules": mensagem.conteudo.rules,
        "append-icon": mensagem.conteudo.icon,
        "autocomplete": mensagem.conteudo.tipo,
        "inputmode": mensagem.conteudo.inputmode,
        "placeholder": mensagem.conteudo.placeholder,
        "data-hj-allow": ""
      },
      model: {
        value: _vm.inputs[mensagem.conteudo.model],
        callback: function callback($$v) {
          _vm.$set(_vm.inputs, mensagem.conteudo.model, $$v);
        },
        expression: "inputs[mensagem.conteudo.model]"
      }
    })], 1) : _vm._e(), mensagem.tipo == 'button' ? _c('div', {
      staticClass: "d-flex"
    }, _vm._l(mensagem.conteudo, function (btn, index) {
      return _c('v-btn', {
        key: index,
        staticClass: "rounded-lg botao-enviar",
        "class": {
          'ml-auto': index == 0,
          'ml-4': index != 0
        },
        attrs: {
          "disabled": _vm.preAutenticando,
          "color": "primary",
          "outlined": btn.outlined,
          "depressed": btn.depressed
        },
        on: {
          "click": btn.func
        }
      }, [_vm._v(" " + _vm._s(_vm.textoDinamico(btn.texto)) + " ")]);
    }), 1) : _vm._e(), mensagem.tipo == 'erro' ? _c('v-alert', {
      staticClass: "mensagem-erro rounded-xl rounded-tl-0 ma-0",
      attrs: {
        "text": "",
        "type": "error"
      }
    }, [_vm._v(" " + _vm._s(mensagem.conteudo) + " ")]) : _vm._e()], 1);
  }), 0), _vm.digitandoMensagem ? _c('div', {
    staticClass: "digitando mt-4 pa-4 mb-4 rounded-xl rounded-tl-0"
  }, [_c('div', {
    staticClass: "dot-flashing"
  })]) : _vm._e()], 1), _vm.mostraRodape ? _c('ml-footer', {
    staticClass: "mt-4 ml-n4"
  }) : _vm._e(), _c('div', {
    staticClass: "botoes-chat-faq"
  }, [!_vm.exibirFaq ? _c('div', {
    staticClass: "text-center pt-3",
    staticStyle: {
      "margin-left": "-16px"
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-help-circle-outline")]), _c('strong', [_c('a', {
    staticClass: "text-decoration-underline",
    attrs: {
      "target": "_blank",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.exibirFaq = true;
      }
    }
  }, [_vm._v(" Precisa de ajuda? ")])])], 1) : _vm._e(), _vm.$store.state.chat.mensagens > 0 && (!_vm.cliente.tem_email || !_vm.cliente.tem_whatsapp || !_vm.cliente.telefone || !_vm.cliente.tem_push) && _vm.exibirFaq ? _c('div', {
    staticClass: "text-center pt-3 sombra-botao-inferior"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-message-text-outline")]), _c('strong', [_c('a', {
    staticClass: "text-decoration-underline",
    attrs: {
      "target": "_blank",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.exibirFaq = false;
      }
    }
  }, [_vm._v(" Voltar para o chat ")])])], 1) : _vm._e()])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };